import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ContractInterventionTariffType {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ContractInterventionTariffType = {
  data: [],
  isLoading: false,
  error: null,
};

const contractInterventionTariffTypeSlice = createSlice({
  name: 'contractInterventionTariffType',
  initialState,
  reducers: {
    setContractInterventionTariffTypes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setContractInterventionTariffTypeLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setContractInterventionTariffTypeError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setContractInterventionTariffTypes,
  setContractInterventionTariffTypeLoading,
  setContractInterventionTariffTypeError,
} = contractInterventionTariffTypeSlice.actions;

export default contractInterventionTariffTypeSlice.reducer;
